import { COMMON_BASE_URL_PREFIX } from '@flowwai-frontend/shared/constants'

export const NO_RESULTS_VIEW_IMG_URL = `${COMMON_BASE_URL_PREFIX}/images/no-results-found.png`
